export const newsData = [
    {
        publishDate: '16/February/2022',
        publishTime: '03:00pm',
        headline: 'অন-লাইন ক্লাস ও মধ্যপর্ব পরীক্ষার নোটিশ',
        description: false,
        file: 'https://www.youtube.com/watch?v=pCBRYuXYSQc',
        source: 'Administrator',
        publisher: 'Abdul jabbar',


    },
    {
        publishDate: '04/February/2022',
        publishTime: '06:00pm',
        description: false,
        headline: 'ডিপ্লেমা ইন ইঞ্জিনিয়ারিং পরীক্ষার উত্তরপত্র পূনঃ নিরীক্ষণ বিজ্ঞপ্তি',
        file: false,
        source: 'Principal',
        publisher: 'Md Nur mohammad'
    }, {
        publishDate: '04/February/2022',
        publishTime: '06:00pm',
        description: false,
        headline: 'Mid term exam notice for all semester',
        file: 'https://scontent.fdac31-1.fna.fbcdn.net/v/t39.30808-6/316800797_3537942323116858_9028506084342224527_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=5cd70e&_nc_eui2=AeEUlKBfnbhZFL3IB2JWhyQpSWWPfav1KMVJZY99q_UoxUjK_0RilSaRzj-6rWzD2YivL7dq5YEbs2MXLVq_ANNQ&_nc_ohc=l258AF-2ldYAX94QcBJ&_nc_ht=scontent.fdac31-1.fna&oh=00_AfDowH0oUYUmyoo711a66s_ZORZ_armQgto9JvAzIm74Rw&oe=639E7C28',
        source: 'Administrator',
        publisher: 'Rabiul Islam'
    }, {
        headline: `📛উপবৃত্তি সংক্রান্ত নিউজ📛`,
        thumbnail: 'img',
        description: `📛উপবৃত্তি সংক্রান্ত নিউজ📛
            উপবৃত্তি প্রাপ্য শিক্ষার্থীদের এন্ট্রিকৃত ডাটা আঞ্চলিক অফিসে জমাদান সংক্রান্তঃ
            🛑১। যে সকল শিক্ষা প্রতিষ্ঠানের শিক্ষার্থীদের ডাটা এন্ট্রি করেছে কিন্তু আঞ্চলিক অফিসে জমাদান করে নি অথবা সংশোধন করার জন্য আঞ্চলিক অফিস থেকে ডাটা ফিরিয়ে নিয়েছেন/দিয়েছেন, সে সকল ডাটা প্রযোজ্য ক্ষেত্রে দ্রুত আঞ্চলিক অফিসে সফটওয়্যার এর মাধ্যমে জমা দান করুন।
            🛑২। উল্লেখ্য, আঞ্চলিক অফিসে জমা দানের সর্বশেষ তারিখ ০৯/০৫/২০২২ শেষ হয়েছে। আগামীকাল ১৪/০৫/২০২২ তারিখ বিকাল ৫ঃ০০ টার পর উপবৃত্তি সফটওয়্যার সার্ভার স্বয়ংক্রিয়ভাবে বন্ধ হয়ে যাবে।
            উপবৃত্তি সেল, কারিগরি শিক্ষা অধিদপ্তর`,
        publishTime: '06:00pm',
        publishDate: '04/February/2022',
        source: 'Administrator',
        publisher: 'Rabiul Islam',
        status: 'Active',
        file: false,
    },
    {
        publishDate: '02/February/2022',
        publishTime: '03:30am',
        headline: 'TEXTILE 4th,5th,6th SEMESTER BOARD RESULT-2021 ',
        description: false,
        file: 'https://scontent.fdac31-1.fna.fbcdn.net/v/t39.30808-6/316800797_3537942323116858_9028506084342224527_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=5cd70e&_nc_eui2=AeEUlKBfnbhZFL3IB2JWhyQpSWWPfav1KMVJZY99q_UoxUjK_0RilSaRzj-6rWzD2YivL7dq5YEbs2MXLVq_ANNQ&_nc_ohc=l258AF-2ldYAX94QcBJ&_nc_ht=scontent.fdac31-1.fna&oh=00_AfDowH0oUYUmyoo711a66s_ZORZ_armQgto9JvAzIm74Rw&oe=639E7C28',
        source: 'Administrator',
        publisher: 'Abdul jabbar'
    },
    {
        publishDate: '22/January/2022',
        publishTime: '12:05pm',
        headline: 'মধ্যপর্ব পরীক্ষার নোটিশ 2022',
        description: false,
        file: 'https://scontent.fdac31-1.fna.fbcdn.net/v/t39.30808-6/316800797_3537942323116858_9028506084342224527_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=5cd70e&_nc_eui2=AeEUlKBfnbhZFL3IB2JWhyQpSWWPfav1KMVJZY99q_UoxUjK_0RilSaRzj-6rWzD2YivL7dq5YEbs2MXLVq_ANNQ&_nc_ohc=l258AF-2ldYAX94QcBJ&_nc_ht=scontent.fdac31-1.fna&oh=00_AfDowH0oUYUmyoo711a66s_ZORZ_armQgto9JvAzIm74Rw&oe=639E7C28',
        source: 'Administrator',
        publisher: 'P.K.S'
    },
    {
        publishDate: '16/January/2022',
        publishTime: '04:00pm',
        headline: 'Vaccine Notice 11-01-2022',
        description: false,
        file: false,
        source: 'bteb',
        publisher: 'Omar faruk'
    },
    {
        publishDate: '12/January/2022',
        publishTime: '09:20pm',
        headline: 'TEXTILE 3rd Semester Result ',
        description: false,
        file: 'https://scontent.fdac31-1.fna.fbcdn.net/v/t39.30808-6/316800797_3537942323116858_9028506084342224527_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=5cd70e&_nc_eui2=AeEUlKBfnbhZFL3IB2JWhyQpSWWPfav1KMVJZY99q_UoxUjK_0RilSaRzj-6rWzD2YivL7dq5YEbs2MXLVq_ANNQ&_nc_ohc=l258AF-2ldYAX94QcBJ&_nc_ht=scontent.fdac31-1.fna&oh=00_AfDowH0oUYUmyoo711a66s_ZORZ_armQgto9JvAzIm74Rw&oe=639E7C28',
        source: 'Administrator',
        publisher: 'Abdul jabbar'
    },
    {
        publishDate: '10/January/2022',
        publishTime: '10:08pm',
        headline: 'ডিপ্লোমা ইন টেক্সটাইল ইঞ্জিনিয়ারিং শিক্ষাক্রমের পুনঃনিরীক্ষণের কার্যক্রম সংক্রান্ত বিজ্ঞপ্তিডিপ্লোমা ইন টেক্সটাইল ইঞ্জিনিয়ারিং শিক্ষাক্রমের পুনঃনিরীক্ষণের কার্যক্রম সংক্রান্ত বিজ্ঞপ্তি',
        description: false,
        file: false,
        source: 'bteb',
        publisher: 'Abdul jabbar'
    },
    {
        publishDate: '09/January/2022',
        publishTime: '06:00pm',
        headline: 'অন-লাইন ক্লাস ও মধ্যপর্ব পরীক্ষার নোটিশ',
        description: false,
        file: 'https://scontent.fdac31-1.fna.fbcdn.net/v/t39.30808-6/316800797_3537942323116858_9028506084342224527_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=5cd70e&_nc_eui2=AeEUlKBfnbhZFL3IB2JWhyQpSWWPfav1KMVJZY99q_UoxUjK_0RilSaRzj-6rWzD2YivL7dq5YEbs2MXLVq_ANNQ&_nc_ohc=l258AF-2ldYAX94QcBJ&_nc_ht=scontent.fdac31-1.fna&oh=00_AfDowH0oUYUmyoo711a66s_ZORZ_armQgto9JvAzIm74Rw&oe=639E7C28',
        source: 'bteb',
        publisher: 'Engr.Mohammad Mustakim'
    },
    {
        publishDate: '06/January/2022',
        publishTime: '12:16pm',
        headline: 'অন-লাইন ক্লাস ও মধ্যপর্ব পরীক্ষার নোটিশ',
        description: false,
        file: false,
        source: 'Vice principal',
        publisher: 'Dr.Md.Haider Alam'
    }, {
        publishDate: '06/December/2021',
        publishTime: '12:16pm',
        headline: 'অন-লাইন ক্লাস ও মধ্যপর্ব পরীক্ষার নোটিশ',
        description: false,
        file: false,
        source: 'Vice principal',
        publisher: 'Dr.Md.Haider Alam'
    }, {
        publishDate: '16/February/2022',
        publishTime: '03:00pm',
        headline: 'অন-লাইন ক্লাস ও মধ্যপর্ব পরীক্ষার নোটিশ',
        description: false,
        file: 'https://www.youtube.com/watch?v=pCBRYuXYSQc',
        source: 'Administrator',
        publisher: 'Abdul jabbar',


    },
    {
        publishDate: '04/February/2022',
        publishTime: '06:00pm',
        description: false,
        headline: 'ডিপ্লেমা ইন ইঞ্জিনিয়ারিং পরীক্ষার উত্তরপত্র পূনঃ নিরীক্ষণ বিজ্ঞপ্তি',
        file: false,
        source: 'Principal',
        publisher: 'Md Nur mohammad'
    }, {
        publishDate: '04/February/2022',
        publishTime: '06:00pm',
        description: false,
        headline: 'Mid term exam notice for all semester',
        file: 'https://scontent.fdac31-1.fna.fbcdn.net/v/t39.30808-6/316800797_3537942323116858_9028506084342224527_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=5cd70e&_nc_eui2=AeEUlKBfnbhZFL3IB2JWhyQpSWWPfav1KMVJZY99q_UoxUjK_0RilSaRzj-6rWzD2YivL7dq5YEbs2MXLVq_ANNQ&_nc_ohc=l258AF-2ldYAX94QcBJ&_nc_ht=scontent.fdac31-1.fna&oh=00_AfDowH0oUYUmyoo711a66s_ZORZ_armQgto9JvAzIm74Rw&oe=639E7C28',
        source: 'Administrator',
        publisher: 'Rabiul Islam'
    }, {
        publishDate: '04/February/2022',
        publishTime: '06:00pm',
        headline: `📛উপবৃত্তি সংক্রান্ত নিউজ📛`,
        description: `📛উপবৃত্তি সংক্রান্ত নিউজ📛
            উপবৃত্তি প্রাপ্য শিক্ষার্থীদের এন্ট্রিকৃত ডাটা আঞ্চলিক অফিসে জমাদান সংক্রান্তঃ
            🛑১। যে সকল শিক্ষা প্রতিষ্ঠানের শিক্ষার্থীদের ডাটা এন্ট্রি করেছে কিন্তু আঞ্চলিক অফিসে জমাদান করে নি অথবা সংশোধন করার জন্য আঞ্চলিক অফিস থেকে ডাটা ফিরিয়ে নিয়েছেন/দিয়েছেন, সে সকল ডাটা প্রযোজ্য ক্ষেত্রে দ্রুত আঞ্চলিক অফিসে সফটওয়্যার এর মাধ্যমে জমা দান করুন।
            🛑২। উল্লেখ্য, আঞ্চলিক অফিসে জমা দানের সর্বশেষ তারিখ ০৯/০৫/২০২২ শেষ হয়েছে। আগামীকাল ১৪/০৫/২০২২ তারিখ বিকাল ৫ঃ০০ টার পর উপবৃত্তি সফটওয়্যার সার্ভার স্বয়ংক্রিয়ভাবে বন্ধ হয়ে যাবে।
            উপবৃত্তি সেল, কারিগরি শিক্ষা অধিদপ্তর`,
        file: false,
        source: 'Administrator',
        publisher: 'Rabiul Islam'
    },
    {
        publishDate: '02/February/2022',
        publishTime: '03:30am',
        headline: 'TEXTILE 4th,5th,6th SEMESTER BOARD RESULT-2021 ',
        description: false,
        file: 'https://scontent.fdac31-1.fna.fbcdn.net/v/t39.30808-6/316800797_3537942323116858_9028506084342224527_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=5cd70e&_nc_eui2=AeEUlKBfnbhZFL3IB2JWhyQpSWWPfav1KMVJZY99q_UoxUjK_0RilSaRzj-6rWzD2YivL7dq5YEbs2MXLVq_ANNQ&_nc_ohc=l258AF-2ldYAX94QcBJ&_nc_ht=scontent.fdac31-1.fna&oh=00_AfDowH0oUYUmyoo711a66s_ZORZ_armQgto9JvAzIm74Rw&oe=639E7C28',
        source: 'Administrator',
        publisher: 'Abdul jabbar'
    },
    {
        publishDate: '22/January/2022',
        publishTime: '12:05pm',
        headline: 'মধ্যপর্ব পরীক্ষার নোটিশ 2022',
        description: false,
        file: 'https://scontent.fdac31-1.fna.fbcdn.net/v/t39.30808-6/316800797_3537942323116858_9028506084342224527_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=5cd70e&_nc_eui2=AeEUlKBfnbhZFL3IB2JWhyQpSWWPfav1KMVJZY99q_UoxUjK_0RilSaRzj-6rWzD2YivL7dq5YEbs2MXLVq_ANNQ&_nc_ohc=l258AF-2ldYAX94QcBJ&_nc_ht=scontent.fdac31-1.fna&oh=00_AfDowH0oUYUmyoo711a66s_ZORZ_armQgto9JvAzIm74Rw&oe=639E7C28',
        source: 'Administrator',
        publisher: 'P.K.S'
    },
    {
        publishDate: '16/January/2022',
        publishTime: '04:00pm',
        headline: 'Vaccine Notice 11-01-2022',
        description: false,
        file: false,
        source: 'bteb',
        publisher: 'Omar faruk'
    },
    {
        publishDate: '12/January/2022',
        publishTime: '09:20pm',
        headline: 'TEXTILE 3rd Semester Result ',
        description: false,
        file: 'https://scontent.fdac31-1.fna.fbcdn.net/v/t39.30808-6/316800797_3537942323116858_9028506084342224527_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=5cd70e&_nc_eui2=AeEUlKBfnbhZFL3IB2JWhyQpSWWPfav1KMVJZY99q_UoxUjK_0RilSaRzj-6rWzD2YivL7dq5YEbs2MXLVq_ANNQ&_nc_ohc=l258AF-2ldYAX94QcBJ&_nc_ht=scontent.fdac31-1.fna&oh=00_AfDowH0oUYUmyoo711a66s_ZORZ_armQgto9JvAzIm74Rw&oe=639E7C28',
        source: 'Administrator',
        publisher: 'Abdul jabbar'
    },
    {
        publishDate: '10/January/2022',
        publishTime: '10:08pm',
        headline: 'ডিপ্লোমা ইন টেক্সটাইল ইঞ্জিনিয়ারিং শিক্ষাক্রমের পুনঃনিরীক্ষণের কার্যক্রম সংক্রান্ত বিজ্ঞপ্তিডিপ্লোমা ইন টেক্সটাইল ইঞ্জিনিয়ারিং শিক্ষাক্রমের পুনঃনিরীক্ষণের কার্যক্রম সংক্রান্ত বিজ্ঞপ্তি',
        description: false,
        file: false,
        source: 'bteb',
        publisher: 'Abdul jabbar'
    },
    {
        publishDate: '09/January/2022',
        publishTime: '06:00pm',
        headline: 'অন-লাইন ক্লাস ও মধ্যপর্ব পরীক্ষার নোটিশ',
        description: false,
        file: 'https://scontent.fdac31-1.fna.fbcdn.net/v/t39.30808-6/316800797_3537942323116858_9028506084342224527_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=5cd70e&_nc_eui2=AeEUlKBfnbhZFL3IB2JWhyQpSWWPfav1KMVJZY99q_UoxUjK_0RilSaRzj-6rWzD2YivL7dq5YEbs2MXLVq_ANNQ&_nc_ohc=l258AF-2ldYAX94QcBJ&_nc_ht=scontent.fdac31-1.fna&oh=00_AfDowH0oUYUmyoo711a66s_ZORZ_armQgto9JvAzIm74Rw&oe=639E7C28',
        source: 'bteb',
        publisher: 'Engr.Mohammad Mustakim'
    },
    {
        publishDate: '06/January/2022',
        publishTime: '12:16pm',
        headline: 'অন-লাইন ক্লাস ও মধ্যপর্ব পরীক্ষার নোটিশ',
        description: false,
        file: false,
        source: 'Vice principal',
        publisher: 'Dr.Md.Haider Alam'
    }, {
        publishDate: '06/December/2021',
        publishTime: '12:16pm',
        headline: 'অন-লাইন ক্লাস ও মধ্যপর্ব পরীক্ষার নোটিশ',
        description: false,
        file: false,
        source: 'Vice principal',
        publisher: 'Dr.Md.Haider Alam'
    },
]